import axiosInst from '../../libs/axios/axios'

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  device:null
}
const getters = {
  newDevice (state) {
    return state.device
  }
}
const mutations = {
  device (state, info) {
    state.device = info
  }
}
const actions = {
  getDeviceData (store, id) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/device/${  id  }/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHiveDeviceData (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/device/hive/${  info}`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHiveDeviceLazyLoadData (store, api) {
    return new Promise((resolve, reject) => {
      axiosInst.get(api).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  addNewDeviceData (store, device) {
    store.commit('device', device)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
